module.exports = __webpack_public_path__ + "static/img/order.c3c73515.png";